module.exports = __webpack_public_path__ + "6c4a0dbc/img/file-icon.c085e21e.svg";